import { CONT_LENS, ICellCGsInfo, IContainerInformation, TCG_IN_MMM, TGetContainersCgsResult } from "@tedivo/tedivo-bay-grid-pure";
import { TContConfigurationSpecs, TContainerNameFn, TContainersSymbolsConfig } from "@tedivo/tedivo-bay-grid-core";
import { feetToMillimeters, roundDec } from "@tedivo/tedivo-pure-helpers";

export function generateTopContSymbols(
  prefixSymbol: string,
  containersWithPositions: TGetContainersCgsResult
): TContainersSymbolsConfig<IContainerInformation> {

  const containersCgsByPk = containersWithPositions.containersCgsByPk;
  const getSizeFromContainerPk = (pk: string): ICellCGsInfo | undefined => containersCgsByPk[pk];
  const getContainerInformationFromPk = (pk: string): IContainerInformation | undefined => {
    const cellInfo = getSizeFromContainerPk(pk);
    if (!cellInfo) return undefined;
    return cellInfo.meta
  }

  const nameFn: TContainerNameFn<IContainerInformation> =
    (prefixSymbol, contInfo) => contInfo ? `${prefixSymbol}_${contInfo.size}` : undefined;

  const config: TContainersSymbolsConfig<IContainerInformation> = {
    prefixSymbol,
    nameFn,
    conts: [],
    pathFn: (lengthInMM: number, heightInMM: number) =>
      `M${-lengthInMM * 0.5},${-heightInMM * 0.5} h${lengthInMM} v${heightInMM} h-${lengthInMM} z`,
    getItem: (pk: string) => getContainerInformationFromPk(pk)
  };

  config.conts = CONT_LENS.map((len) => {
    const name = nameFn(prefixSymbol, { size: len } as IContainerInformation, 0);
    if (!name) return;

    return {
      name,
      lengthInMM: roundDec(feetToMillimeters(len), 0),
      heightInMM: TCG_IN_MMM,
      fillColor: "#ffffff",
      strokeColor: "#d4d4d8",
      fillOpacity: 0.5,
      strokeOpacity: 0.66,
      strokeWidth: 2,
      strokeDashLength: 1.5,
      dashInTheMiddle: len >= 40,
    };
  }).filter(Boolean) as TContConfigurationSpecs[];

  return config;
}
